export default "__VITE_ASSET__bb917c99__"